<template>
    <el-dialog :visible.sync="visible"
                :title="$t('privateNetInstance.fixSOS')"
                :close-on-click-modal="false"
                :before-close="handleClose" class="bind-dialog">
            <div class="i-text">
                <div class="tip-warning mb20 lh20"
                >{{$t('privateNetInstance.fixSOSTips1')}}
                  <a v-bind:href="Config.SOS_URL" target="_blank">{{$t('privateNetInstance.operateGuid')}}</a>{{'。'}}</br>
                  {{$t('privateNetInstance.fixSOSTips2')}}
                </div>    
            </div>
            <el-table :data="sshList"
                    style="width: 100%;"
                    max-height="242"
                    class="bind-flex-net">
                    <el-table-column label="" min-width="16">
                        <template scope="scope">
                        <el-radio v-model="radioVal"
                                    :label="scope.$index">
                            {{ '' }}
                        </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                    :label="$t('privateNetInstance.sshName')">
                        <template scope="scope">
                        <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="region"
                                    :label="$t('create.text.region')">
                        <template scope="scope">
                        <span>{{transformRegion( scope.row.region )}}</span>
                        </template>
                    </el-table-column>
            </el-table>
            <div slot="footer">
            <el-button @click="cancelBind">
                {{ $t('privateNetInstance.cancel') }}
            </el-button>
            <el-button @click="sureBind"
                        type="primary"
                        :disabled="radioVal === ''">
                {{ $t('privateNetInstance.bindSure') }}
            </el-button>
            </div>
    </el-dialog>
</template>

<script>
export default {
  name: 'BindFlexNet',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowInfo: {
      type:Object,
      default:{}
    },

  },
  data() {
    return {
      sshList: [],
      radioVal: '',
      regions:[],
      current: {},
    };
  },
  created() {
    
	},
  methods: {
    handleClose() {
      this.radioVal = '';
      this.current = {};
      this.$emit('update:visible', false);
    },
    cancelBind() {
      this.handleClose();
    },
    sureBind() {
      const params = {
        region: this.rowInfo.region,
        instanceId: this.rowInfo.instanceId,
        keypairIdSos: this.current.keypairId,
        clientToken: Normal.getClientToken(),

      };
      Ajax.post('/api/cps/modifyInstanceSos', params)
        .then((res) => {
           this.$message.success(this.$t('privateNetInstance.operateSuccess'));
        })
        .catch(async (err) => {
          const { response } = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally(() => {
          this.handleClose();
          this.$emit('refresh');
        });
    },
    getRegions() {
        const params = {
				networkType: 'vpc'
			};
      Ajax.get('api/cps/getRegions',params)
      .then((res) => {
        res.data.regions.forEach((region) => {
          this.regions[region.region] = region.regionName;
        });
      });
    },
    transformRegion(region) {
      return this.regions[region];
    },
    getSshList() {
      const params = {
        region: this.rowInfo.region,
        pageNumber: 1,
        pageSize: 1000,
      };
      Ajax.get('/api/cps/listKeypairs', params)
        .then((res) => {
            this.sshList = res.data.keypairs;
        })
        .catch(async (err) => {
          const {response} = err.data;
          try {
            const json = await response.json();
            target.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally();
    },
  },
  watch: {
    radioVal(newVal, oldVal) {
      if (newVal !== '') {
        this.current = this.sshList[newVal];
      }
    },
    visible(val) {
      if(val===true) {
          this.getRegions();
          this.getSshList();
      }
    }
  },
};
</script>

<style lang="scss">
  .bind-dialog {
    .el-alert {
      .el-alert__title {
        word-break: break-all !important;
      }
    }

    .bind-flex-net {
      .el-radio {
        .el-radio__label {
          padding-left: 0;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/common/FixSos.vue